import React from "react";

const Toolbar = ({
  count,
  deleteCourseMaterials,
  onChangeQuery,
  query,
  handleCourseMaterialModal,
}) => {
  return (
    <div>
      <div className="container_admin_user">
        <div className="col s4 search_admin">
          <input id="search" type="submit" className="validate" />
          <label htmlFor="search">
            <i className="material-icons icon_search">search</i>
          </label>
          <input
            type="search"
            placeholder="Search"
            value={query.search}
            onChange={(e) => onChangeQuery("search", e.target.value)}
          />
          <i
            onClick={(e) => onChangeQuery("search", "")}
            className="material-icons icon_close"
          >
            close
          </i>
        </div>
      </div>
      <div className="admin_list">
        <h5>
          Course materials (<span>{count}</span>)
        </h5>
        <a
          className="button_classic"
          onClick={() => handleCourseMaterialModal()}
        >
          Add new course material
        </a>
        <a className="button_delete" onClick={deleteCourseMaterials}>
          Delete
        </a>
      </div>
    </div>
  );
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/CourseMaterials/Toolbar.jsx